import { render, staticRenderFns } from "./Error-4.vue?vue&type=template&id=49518a20&"
import script from "./Error-4.vue?vue&type=script&lang=js&"
export * from "./Error-4.vue?vue&type=script&lang=js&"
import style0 from "./Error-4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports